import React, {Component} from 'react'
import {Router} from '@reach/router'
import './App.scss'

import TPHeader from './components/TPHeader/TPHeader'
import TPFooter from './components/TPFooter/TPFooter'
import Home from './pages/Home/Home'
import BankStatements from './pages/BankStatements/BankStatements'

class App extends Component {
  render() {
    return (
      <div className="app">
        <TPHeader/>
        <Router className="content" basepath="/bank-statements">
          <Home path="/" default/>
          <BankStatements path="/:loanEnquiryDetailId"/>
        </Router>
        <TPFooter/>
      </div>
    )
  }
}

export default App
